import React from "react";

import ModalMotion, {
  AnimateDirection,
} from "@/components/Molecules/ModalMotion";
import Typography from "@/foundation/Typography/V2";

import DownloadPDFForm from "./DownloadPDFForm";
import DownloadPDFSuccess from "./DownloadPDFSuccess";
import useDownloadPDFForm from "./DownloadPDFForm/useDownloadPDFForm";

import { classNameGenerator } from "@/utils";

import styles from "./DownloadPDFModal.module.scss";

interface DownloadPDFModalProps {
  title: string;
  description: string;
  onClose: () => void;
  campaignSlug: string;
}

const DownloadPDFModal: React.FC<DownloadPDFModalProps> = ({
  title,
  description,
  onClose,
  campaignSlug,
}) => {
  const cls = classNameGenerator(styles);

  const { isLoading, handleBlur, onSubmit, methods, showSuccessScreen } =
    useDownloadPDFForm({
      onClose,
      campaignSlug,
    });

  const FormInputsComp = (
    <div className={cls("form-wrapper")} id="download-pdf-modal">
      <div className={cls("header")}>
        <Typography
          variant="heading2"
          className={cls("title")}
          dangerouslySetInnerHTML={{
            __html: `Download our complete guide for ${title}`,
          }}
        />
        <Typography
          variant="paragraph1"
          className={cls("description")}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
      <DownloadPDFForm
        isLoading={isLoading}
        handleBlur={handleBlur}
        onSubmit={onSubmit}
        methods={methods}
      />
    </div>
  );

  const { mobile, email } = showSuccessScreen || {};

  const SuccessModalComp = (
    <DownloadPDFSuccess title={title} mobile={mobile} email={email} />
  );

  const component = showSuccessScreen ? SuccessModalComp : FormInputsComp;

  return (
    <ModalMotion
      overlayClosable
      onClose={onClose}
      width="500px"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      className={cls("downloadPDFModal")}
    >
      {component}
    </ModalMotion>
  );
};

export default DownloadPDFModal;
